import { AppointmentsFilters } from './AppointmentsFilters';
import { AppointmentsViewToggle } from './AppointmentsViewToggle';
import type { StanFilterValue } from '@/components/core-components/StanFilters/types';

interface ListHeaderProps {
    filterValues: StanFilterValue[];
    onFilterChanged: (filters: StanFilterValue[]) => void;
    onResetFilters: () => void;
    viewMode: 'calendar' | 'list';
    onViewModeChange: (mode: 'calendar' | 'list') => void;
}

export function ListHeader({
    filterValues,
    onFilterChanged,
    onResetFilters,
    viewMode,
    onViewModeChange,
}: ListHeaderProps) {
    return (
        <div className='mb-6 flex flex-col gap-3 md:flex-row md:items-center md:justify-between'>
            <div className='md:hidden'>
                <AppointmentsViewToggle viewMode={viewMode} onViewModeChange={onViewModeChange} />
            </div>

            <AppointmentsFilters
                filterValues={filterValues}
                onFilterChanged={onFilterChanged}
                onResetFilters={onResetFilters}
            />

            <div className='hidden md:block'>
                <AppointmentsViewToggle viewMode={viewMode} onViewModeChange={onViewModeChange} />
            </div>
        </div>
    );
}
